import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface DataZoomEvent {
  type: string;
  batch: {
    start: number;
    end: number;
  }[];
}

@Injectable()
export class ChartZoomService {
  private zoomSubject = new BehaviorSubject<{ start: number; end: number } | null>(null);

  get zoom$() {
    return this.zoomSubject.asObservable();
  }

  setZoom(zoomEvent: DataZoomEvent) {
    if (zoomEvent.batch && zoomEvent.batch.length > 0) {
      const zoomData = zoomEvent.batch[0];
      const start = zoomData.start;
      const end = zoomData.end;
      this.zoomSubject.next({ start, end });
    }
  }
}
